import React from 'react'
import PropTypes from 'prop-types'

import Text from '@hixme-ui/text'
import { FormGroup, Checkbox } from '@hixme-ui/forms'

import cx from 'helpers/cx'
import { FieldComponent } from 'components/ReduxFormComponents'
import FormActions from 'components/FormActions'
import { Button } from 'components'

import classes from './TermsAndConditionsForm.module.scss'

const TermsAndConditionsForm = ({ handleSubmit, submitting, disableForm }) => (
  <form onSubmit={handleSubmit} className={classes.form}>
    <Text warning small role="status">
      * You must scroll through the entire Terms &amp; Conditions to proceed.
    </Text>
    <div className={cx('card-style', classes.consent)}>
      <div className={classes.consentField}>
        <div className={cx(classes.consentCheckbox, disableForm && classes.consentCheckboxDisabled)}>
          <FormGroup style={{ marginBottom: 0 }}>
            <FieldComponent
              inputComponent={Checkbox}
              text="I agree to the Terms & Conditions."
              name="TermsAndConditionsAgreed"
              disabled={disableForm}
            />
          </FormGroup>
        </div>
      </div>
    </div>
    <FormActions>
      <Button
        type="submit"
        variant="primary"
        size="lg"
        block
        loading={submitting}
        loadingText="Submitting..."
        disabled={disableForm}
      >
        Save & continue
      </Button>
    </FormActions>
  </form>
)

TermsAndConditionsForm.propTypes = {
  submitting: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  disableForm: PropTypes.bool.isRequired,
}

export default TermsAndConditionsForm
